import { apiInstance } from "@apis";
import { IExportAttachmentsDto, IExportPDFDto } from "@types";

export const exportPDFUserService = async (
  profileId: string,
  payload: IExportPDFDto,
) => {
  await apiInstance.post(`/v1/profile/${profileId}/export-pdf`, payload);
};

export const exportAttachmentsUserService = async (
  payload: IExportAttachmentsDto,
) => {
  await apiInstance.post(`/v1/file/export/zip`, payload);
};
